import { Component } from '@verndale/core';

class PdpStorageHandler extends Component {
  constructor(el: HTMLElement) {
    super(el);

    setTimeout(()=> {
      this.setupStorage();
    }, 1000);
  }

  setupStorage() {
    const insightsObjectId = (document.querySelector('#documentId') as HTMLInputElement).value;
    const boatBrand = (document.querySelector('#boatBrand') as HTMLInputElement).value;

    if (insightsObjectId && boatBrand) {
      console.log('insightsObjectId', insightsObjectId);

      // Check if the item exists in localStorage
      const storedData = window.localStorage.getItem('VISITED_BOATS');
      if (!storedData) {
        // If not set, initialize with current item
        window.localStorage.setItem('VISITED_BOATS', JSON.stringify([{ id: insightsObjectId, brand: boatBrand }]));
        
        // Set cookie with the first brand
        document.cookie = `PopularBrand=${boatBrand}; path=/; max-age=${60 * 60 * 24 * 30}`; // 30 days
        return;
      }

      // Get existing array from localStorage
      const existingItems = JSON.parse(storedData);

      // Check if item already exists in the array
      const existingItemIndex = existingItems.findIndex((item: { id: string }) => item.id === insightsObjectId);
      
      if (existingItemIndex === -1) {
        // Item doesn't exist in the array
        // If array is full (length 6), remove the last item
        if (existingItems.length >= 6) {
          existingItems.pop();
        }

        // Add new item to the beginning of the array
        existingItems.unshift({ id: insightsObjectId, brand: boatBrand });
      } else {
        // Item exists, remove it from its current position
        const existingItem = existingItems.splice(existingItemIndex, 1)[0];
        // Add it to the beginning of the array
        existingItems.unshift(existingItem);
      }

      // Save updated array back to localStorage
      window.localStorage.setItem('VISITED_BOATS', JSON.stringify(existingItems));

      // Find the most popular brand
      const brandCounts: Record<string, number> = {};
      existingItems.forEach((item: { brand: string }) => {
        if (item.brand) {
          brandCounts[item.brand] = (brandCounts[item.brand] || 0) + 1;
        }
      });

      // Get the brand with the highest count
      let mostPopularBrand = '';
      let highestCount = 0;
      
      for (const brand in brandCounts) {
        if (brandCounts[brand] > highestCount) {
          mostPopularBrand = brand;
          highestCount = brandCounts[brand];
        }
      }

      // Set cookie with the most popular brand
      if (mostPopularBrand) {
        document.cookie = `PopularBrand=${mostPopularBrand}; path=/; max-age=${60 * 60 * 24 * 30}`; // 30 days
      }
      document.cookie = `ReturningExperience=true; path=/; max-age=${60 * 60 * 24 * 30}`; // 30 days
    }
  }
}

export default PdpStorageHandler;
